export enum IdVerificationVendorEnum {
  ubble = 'ubble',
  checkout = 'checkout',
}
